/**
 * Phase 46 (Plan 46-07) — Event-kind label with hover tooltip.
 *
 * Consumed by NotificationRoutingMatrix row headers + NotificationsAuditPage
 * rows + NotificationAuditDrawer detail. Renders the human label from
 * EVENT_KIND_LABELS and exposes the full tooltip copy via the `title`
 * attribute.
 */
import {
  EVENT_KIND_LABELS,
  EVENT_KIND_TOOLTIPS,
  type EventKind,
} from '../../constants/notificationEnums';

export interface EventKindLabelProps {
  kind: EventKind;
  className?: string;
}

export function EventKindLabel({ kind, className = '' }: EventKindLabelProps) {
  return (
    <span className={className} title={EVENT_KIND_TOOLTIPS[kind]}>
      {EVENT_KIND_LABELS[kind]}
    </span>
  );
}
